import { ValidatorRules } from '../../../tradebuilder-v2/util/validator'
import { BankUsersState } from '../bank-users-slice'

export const bankUserRules: ValidatorRules<BankUsersState> = {
  first_name: [
    (state: BankUsersState) => ({
      isValid: state.selectedUser.firstName.length > 0,
      message: 'User must have a first name'
    })
  ],
  last_name: [
    (state: BankUsersState) => ({
      isValid: state.selectedUser.lastName.length > 0,
      message: 'User must have a last name'
    })
  ],
  email: [
    (state: BankUsersState) => ({
      isValid: state.selectedUser.email.length > 0,
      message: 'User must have a valid email address'
    })
  ],
  role: [
    (state: BankUsersState) => ({
      isValid: state.selectedUser.role !== '',
      message: 'Please select a role'
    })
  ]
}
